import { render } from "./SurgeryLogTable.vue?vue&type=template&id=f8b468d0&scoped=true"
import script from "./SurgeryLogTable.vue?vue&type=script&lang=js"
export * from "./SurgeryLogTable.vue?vue&type=script&lang=js"

import "./SurgeryLogTable.vue?vue&type=style&index=0&id=f8b468d0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b468d0"]])

export default __exports__